<template>
  <modal @@click="close">
      <div  @click.stop class="wrapper">
          <button class="close-btn" @click="close">✕</button>
          <img :src="getImg()" class="pj" alt="pj" />
      </div>
  </modal>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import Modal from './Modal.vue';

export default defineComponent({
    emits: ['close'],
    components: {
        Modal
    },
    props: {
        data: { type: ArrayBuffer, required: true },
        contentType: String
    },
    methods: {
        getImg(){
            const blob = new Blob([this.data], { type: this.contentType });
            return URL.createObjectURL(blob);
        },
        close() {
            this.$emit('close');
        },
    }
});
</script>

<style scoped>
.pj {
    object-fit: contain;
    height: 70vh;
}
.wrapper {
    position: relative;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    background: black;
    color: white;
    border: none;
    padding: 6px 10px;
    cursor: pointer;
}
</style>
